module.exports = __webpack_public_path__ + "img/publish-survey-ted.6905fa1d.svg";